export default "__VITE_ASSET__D9af5g7A__"